import {useEffect, useState} from "react";
import {LineInMain} from "../../models/LineInMain";
import {Table} from "antd";
import {useDispatch} from "react-redux";
import {CHANGE_COMP} from "../../store";
import {useNavigate} from "react-router-dom";
import {FOUR_SPORT_LIVE_URL} from "../../constants";


export interface ICaruzEventsResponse {
    compLines: LineInMain[]
}

export default function Events() {
    const [compLines, setCompLines] = useState<LineInMain[]>([])
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch({
            type: CHANGE_COMP,
            payload: {
                comp: null
            },
        })
    }, [dispatch])

    useEffect(() => {
        fetch(`${FOUR_SPORT_LIVE_URL}/caruz/getCaruzEvents/`, {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('caruzToken')
            },
            credentials: "omit"
        }).then(response => response.json()).then((response: ICaruzEventsResponse) => {
            setCompLines(LineInMain.instantiateFromArr(response.compLines))
        })
    }, [])

    const columns = [
        {
            title: 'comp',
            dataIndex: 'comp',
            key: 'comp',
        },
        {
            title: 'description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'date',
            dataIndex: 'date',
            key: 'date',
        },

    ]

    return (
        <div style={{width: '100%', textAlign: 'center', background: 'white'}}>
            <Table
                style={{maxWidth: '900px',width: '100%', display: 'inline-block', cursor: 'pointer'}}
                dataSource={compLines}
                columns={columns}
                pagination={false}
                rowClassName={(_record, index) =>
                    index % 2 === 0 ? 'odd-row' : ''
                }
                onRow={(compLine, index) => ({
                    onClick: () => {
                        dispatch({
                            type: CHANGE_COMP,
                            payload: {
                                comp: compLine.comp
                            }
                        })
                        navigate(`/events/${compLine.comp}/participants`)
                    }
                })}
            />
        </div>
    )
}